import React from 'react';
import PropTypes from 'prop-types';
import QsHeader from './components/QsHeader'
import CreateQuestion from './components/CreateQuestion'
import { component_tool } from '@/tool'
const { WizComponent, WizLayout, WizButton } = component_tool;
const { Header, Content, Footer } = WizLayout;
import '@/styles/components/question/questionPreview/index.less'
export default class QsPreview extends WizComponent {

    // submit = () => {
    //     wizNotice.warn('当前为问卷预览页面，只能预览，不能提交！')
    // }

    render() {
        const { data } = this.props
        const { preview, title, intro, submissionDate, userName, fullName, questions,yunCall,outEntityType,aboutType,parentEntityId } = data
        const qsheaderProps = { preview, title, intro, submissionDate, userName, fullName }
        const createQuestionProps = { preview, questions,yunCall,outEntityType,aboutType,parentEntityId,data }

        return (
            <WizLayout className="full-layout question-preview">
                <Header>
                    <QsHeader { ...qsheaderProps } />
                </Header>
                <Content>
                    <CreateQuestion { ...createQuestionProps } />
                </Content>
                <Footer>
                    {/*{ preview? <WizButton type="primary" onClick={ this.submit } style={{ marginTop: 30, paddingLeft: 50, paddingRight: 50 }}>提交</WizButton>: null }*/}
                </Footer>
            </WizLayout>
        )
    }

}
